export default "__VITE_ASSET__BTvszmzY__"